// Strip recipient phone numbers from PostHog events before they leave the
// browser (#351). Checkout and recharge URLs carry `?phone=%2B66…`, which
// lands in $current_url, $referrer, $initial_* person props and autocaptured
// link hrefs. Analytics never needs the number, so every string value in the
// event is rewritten to `phone=REDACTED`.

const PHONE_PARAM = /([?&]phone=)[^&#]*/gi;

export function scrubPhone(value, depth = 0) {
  if (typeof value === 'string') return value.replace(PHONE_PARAM, '$1REDACTED');
  if (!value || typeof value !== 'object' || depth > 5) return value;
  if (Array.isArray(value)) return value.map((v) => scrubPhone(v, depth + 1));
  const out = {};
  for (const k of Object.keys(value)) out[k] = scrubPhone(value[k], depth + 1);
  return out;
}

// posthog.init `before_send` hook.
export function beforeSend(event) {
  if (!event) return event;
  for (const k of ['properties', '$set', '$set_once']) {
    if (event[k]) event[k] = scrubPhone(event[k]);
  }
  return event;
}
